import { spiritoryWebApi } from '@/lib/axios/SpiritoryWebApi/spiritoryWebApi';
import { BlogPost } from '@/types/Blog';

export default async function getPaginatedBlogPosts(
  locale: string,
  page: number,
  pageSize: number
) {
  const {
    data: {
      data: { blogs, meta },
    },
  } = await spiritoryWebApi.get('/blog/all', {
    params: { locale, page, pageSize },
  });
  return { data: blogs as BlogPost[], meta };
}
